import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "not-enough-memory__body" }, [
  /*#__PURE__*/_createTextVNode("If this issue persists, "),
  /*#__PURE__*/_createElementVNode("a", null, "contact support.")
], -1)

import UnsupportedPage from '@/components/unsupported-pages/UnsupportedPage.vue'
import GtmHelper from '@/analytics/gtm-helper'


export default /*#__PURE__*/_defineComponent({
  __name: 'NotEnoughMemory',
  setup(__props) {

GtmHelper.getInstance().triggerNotEnoughMemoryEvent()


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UnsupportedPage, { class: "not-enough-memory" }, {
    title: _withCtx(() => [
      _createTextVNode(" Hey! Your device doesn’t have enough available memory to run Serato Visualizer. "),
      _hoisted_1,
      _createTextVNode(" Try closing any unnecessary browser tabs and apps where possible. ")
    ]),
    body: _withCtx(() => [
      _hoisted_2
    ]),
    _: 1
  }))
}
}

})